import Client from "..";
import { Global } from "../utils/Global";
import { GameEvents } from "../utils/Types";

export class SpinsLeft extends Phaser.GameObjects.BitmapText {
  constructor(scene: Phaser.Scene) {
    super(
      scene,
      0,
      0,
      "fnt_paintBasic",
      `Spins Left: ${Client.state!.availableSpins}`,
      Math.max(Global.minFontSize, 16),
    );

    this.scene.game.events.on(
      GameEvents.AVAILABLE_SPINS_UPDATED,
      this.updateSpinsLeft,
      this,
    );
  }

  private updateSpinsLeft(spins: number) {
    this.setText(`Spins Left: ${spins}`);
    this.setFontSize(Math.max(Global.minFontSize, 16));
  }
}
